import { render, staticRenderFns } from "./expand-column.vue?vue&type=template&id=6e7646cc&scoped=true"
import script from "./expand-column.vue?vue&type=script&lang=js"
export * from "./expand-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7646cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7646cc')) {
      api.createRecord('6e7646cc', component.options)
    } else {
      api.reload('6e7646cc', component.options)
    }
    module.hot.accept("./expand-column.vue?vue&type=template&id=6e7646cc&scoped=true", function () {
      api.rerender('6e7646cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reports/inbound-texts/expand-column.vue"
export default component.exports